module.exports = __webpack_public_path__ + "static/media/cdc.5e45c2cf.jpg";